/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 *//* ==========================================================================
   GOLD ART INDIA – FOCAL CART DRAWER (APP "GRAB THIS DEAL")
   ZERO-FLICKER VERSION: open drawer only AFTER cart item_count increases
   ========================================================================== */

(function () {
  let lock = false;

  function isGrabDealButton(el) {
    if (!el) return false;
    const text = (el.textContent || "").trim().toLowerCase();
    return text.includes("grab this deal") || text.includes("grab deal");
  }

  async function getCartItemCount() {
    try {
      // cart.js is standard Shopify endpoint returning JSON
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return null;
      const cart = await res.json();
      return typeof cart.item_count === "number" ? cart.item_count : null;
    } catch (e) {
      return null;
    }
  }

  function refreshCartUI() {
    try {
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    } catch (e) {}
  }

  function openCartDrawer() {
    // Focal mini-cart drawer
    const miniCart = document.getElementById("mini-cart");
    if (miniCart && "open" in miniCart) {
      miniCart.open = true;
      return true;
    }

    // Fallback: click cart icon
    const cartToggle = document.querySelector(
      'button[aria-controls="mini-cart"], button[aria-controls*="cart"], .header__icon--cart, .header__icon-cart, a[href="/cart"], a[href="/cart/"]'
    );
    if (cartToggle) {
      cartToggle.click();
      return true;
    }

    return false;
  }

  async function waitForCartIncrease(previousCount, maxMs) {
    const start = Date.now();
    const pollEvery = 120; // ms (smooth, low-load)

    while (Date.now() - start < maxMs) {
      const current = await getCartItemCount();
      if (current !== null && previousCount !== null && current > previousCount) {
        return true;
      }
      // If we couldn't read count, still keep trying briefly
      await new Promise((r) => setTimeout(r, pollEvery));
    }
    return false;
  }

  document.addEventListener(
    "click",
    async function (e) {
      const el = e.target.closest("button, a, [role='button'], input[type='button'], input[type='submit']");
      if (!el) return;
      if (!isGrabDealButton(el)) return;

      // Prevent double triggers if user taps quickly
      if (lock) return;
      lock = true;

      // Read cart BEFORE app adds product
      const beforeCount = await getCartItemCount();

      // Now wait until cart count increases (app completes add-to-cart)
      // Tune max wait: 2500ms covers slow networks, still feels instant on normal
      const increased = await waitForCartIncrease(beforeCount, 2500);

      // Refresh UI, then open drawer (ONLY now)
      refreshCartUI();

      // tiny micro-delay so refreshed DOM is ready (prevents "refresh jump")
      setTimeout(() => {
        openCartDrawer();
      }, 60);

      // If count didn’t increase (rare), still open after a safe fallback
      if (!increased) {
        setTimeout(() => {
          refreshCartUI();
          openCartDrawer();
        }, 700);
      }

      // release lock
      setTimeout(() => {
        lock = false;
      }, 800);
    },
    true
  );
})();document.addEventListener("click", async (e) => {
  // Qty controls
  const minus = e.target.closest("[data-qty-minus]");
  const plus  = e.target.closest("[data-qty-plus]");

  if (minus || plus) {
    const wrap = e.target.closest("[data-sticky-qty]");
    if (!wrap) return;

    const input = wrap.querySelector(".product-sticky-form__qty-input");
    if (!input) return;

    const current = parseInt(input.value || "1", 10);
    const next = minus ? Math.max(1, current - 1) : Math.max(1, current + 1);

    input.value = String(next);
    input.dispatchEvent(new Event("change", { bubbles: true }));
    return;
  }

  // Sticky Buy Now
  const buyNow = e.target.closest("[data-sticky-buy-now]");
  if (!buyNow) return;

  buyNow.setAttribute("disabled", "disabled");

  // 1) Try to click the existing Buy Now button on the page (Shiprocket/app)
  const candidates = [
    ".shopify-payment-button__button",
    "button[name='checkout']",
    "button[data-buy-now]",
    "button[id*='BuyNow']",
    "button[class*='buy-now']",
    "button[class*='BuyNow']",
    "button"
  ];

  let targetBtn = null;

  for (const sel of candidates) {
    const nodes = Array.from(document.querySelectorAll(sel)).filter(el => {
      if (!(el instanceof HTMLElement)) return false;
      if (el.disabled) return false;

      const rect = el.getBoundingClientRect();
      if (rect.width < 20 || rect.height < 20) return false;

      if (sel === "button") {
        const text = (el.innerText || "").trim().toLowerCase();
        return text === "buy now";
      }

      return true;
    });

    if (nodes.length) { targetBtn = nodes[0]; break; }
  }

  if (targetBtn) {
    targetBtn.click();
    buyNow.removeAttribute("disabled");
    return;
  }

  // 2) Fallback: add selected variant then go to checkout
  try {
    const variantInput =
      document.querySelector('input[name="id"][type="hidden"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');

    const id = variantInput ? parseInt(variantInput.value, 10) : null;

    const qtyInput = document.querySelector(".product-sticky-form__qty-input");
    const qty = qtyInput ? Math.max(1, parseInt(qtyInput.value || "1", 10)) : 1;

    if (!id) throw new Error("Variant id not found");

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id, quantity: qty })
    });

    if (!res.ok) throw new Error(await res.text());

    window.location.href = "/checkout";
  } catch (err) {
    console.error("Sticky Buy Now failed:", err);
    buyNow.removeAttribute("disabled");
  }
});
